<button
  #parent
  (click)="onClick($event)"
  [class.ui-check_disabled]="disabled"
  [class.ui-check_checked]="!isFull && value"
  class="ui-check"
  type="button"
></button>
